import { useEffect } from 'react';

import { PRIVACY_URL } from '../legal/legalLinks.js';

// The in-app privacy policy content is obsolete; for now /privacy-policy
// forwards to the canonical hosted notice. Kept as an SPA route (rather than
// dropped) so existing links to /privacy-policy keep working.
//
// The URL itself lives in legal/legalLinks.js, alongside the terms, so this
// redirect and the surfaces that offer both documents (the Legal screen, the
// signed-out footer) cannot drift apart. The name is re-exported because it is
// what this module has always been imported for.
export const PRIVACY_NOTICE_URL = PRIVACY_URL;

export default function PrivacyPolicy() {
  useEffect(() => {
    // replace() so the interstitial isn't a back-button trap.
    window.location.replace(PRIVACY_NOTICE_URL);
  }, []);

  return (
    <main className="app-shell">
      <p>
        Redirecting to the Halo privacy notice. If you are not redirected
        automatically, <a href={PRIVACY_NOTICE_URL}>open it here</a>.
      </p>
    </main>
  );
}
